// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"80e9d602","703":"b91372de"}[chunkId] + ".chunk.css";
};